var map = {
	"./1/room-2.jpg": "f063",
	"./2/room-2.jpg": "ba9e",
	"./3/room-2.jpg": "258a",
	"./4/room-2.jpg": "8933",
	"./5/room-2.jpg": "ea7a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4e54";